export default function LegalServices() {
  const services = [
    {
      icon: "ri-robot-line",
      title: "Customized AI Agents for Law Firms",
      description: "Enhancing Legal Efficiency and Client Support",
      features: [
        "24/7 Client Support & Inquiry Handling",
        "Automated Document Review & Analysis",
        "Case Management & Scheduling",
        "Legal Research Assistance",
        "Multi-language Support (Arabic & English)"
      ]
    },
    {
      icon: "ri-user-voice-line",
      title: "AI-Powered Legal Avatars",
      description: "Your Digital Legal Representative",
      features: [
        "Virtual Legal Consultations",
        "Interactive Client Engagement",
        "Personalized Legal Guidance",
        "Scalable Client Service",
        "Brand Representation"
      ]
    },
    {
      icon: "ri-folder-cloud-line",
      title: "Centralized Intelligent File Manager",
      description: "Your Low-Code, AI-Integrated Document Brain",
      features: [
        "Smart Document Organization",
        "AI-Powered Search & Retrieval",
        "Version Control & Tracking",
        "Secure Cloud Storage",
        "Automated Categorization"
      ]
    },
    {
      icon: "ri-book-open-line",
      title: "Comprehensive Legal & AI Tools Directory",
      description: "Access to cutting-edge legal technology resources",
      features: [
        "Curated Tool Recommendations",
        "Integration Support",
        "Training & Tutorials",
        "Best Practices Guide",
        "Regular Updates"
      ]
    },
    {
      icon: "ri-smartphone-line",
      title: "AI-Powered Communication & Attendance System",
      description: "Customized for Law Firm Operations",
      features: [
        "Staff Attendance Tracking",
        "Internal Communication Platform",
        "Task Management",
        "Performance Analytics",
        "Mobile Access"
      ]
    },
    {
      icon: "ri-graduation-cap-line",
      title: "Deep Course: Using ChatGPT for Lawyers",
      description: "A Bilingual Guide (Arabic & English)",
      features: [
        "Practical AI Applications",
        "Legal Research Techniques",
        "Document Drafting with AI",
        "Ethical Considerations",
        "Hands-on Exercises"
      ]
    },
    {
      icon: "ri-bar-chart-line",
      title: "Competitor Analysis",
      description: "Identifying Strengths, Weaknesses, & Marketing Strategies",
      features: [
        "Market Position Assessment",
        "Service Comparison",
        "Pricing Analysis",
        "Digital Presence Evaluation",
        "Strategic Recommendations"
      ]
    },
    {
      icon: "ri-line-chart-line",
      title: "Benchmarking Against Competitors",
      description: "Discovering Growth Opportunities",
      features: [
        "Performance Metrics",
        "Industry Standards",
        "Gap Analysis",
        "Improvement Roadmap",
        "Competitive Advantages"
      ]
    },
    {
      icon: "ri-stock-line",
      title: "Market Trend Analysis",
      description: "Anticipating Changes in the Legal Landscape",
      features: [
        "Industry Forecasting",
        "Emerging Technologies",
        "Regulatory Changes",
        "Client Behavior Patterns",
        "Strategic Planning"
      ]
    },
    {
      icon: "ri-group-line",
      title: "Client Demographics Analysis",
      description: "Understanding Client Preferences, Needs, and Behaviors",
      features: [
        "Target Audience Profiling",
        "Behavioral Insights",
        "Service Preferences",
        "Communication Channels",
        "Satisfaction Metrics"
      ]
    },
    {
      icon: "ri-pie-chart-line",
      title: "Data-Driven Decision Making",
      description: "Strategic Planning for Service Expansion and Marketing",
      features: [
        "Business Intelligence",
        "Predictive Analytics",
        "ROI Optimization",
        "Resource Allocation",
        "Growth Strategies"
      ]
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Revenue Growth & Competitive Positioning",
      description: "Discovering Untapped Legal Services",
      features: [
        "Revenue Stream Analysis",
        "Market Opportunities",
        "Service Diversification",
        "Pricing Strategies",
        "Brand Differentiation"
      ]
    },
    {
      icon: "ri-image-line",
      title: "Legal Infographic Design",
      description: "Simplifying Complex Information",
      features: [
        "Visual Content Creation",
        "Data Visualization",
        "Client Education Materials",
        "Social Media Graphics",
        "Presentation Design"
      ]
    },
    {
      icon: "ri-search-2-line",
      title: "AI-Powered Legal Research Tools",
      description: "Fast Case Law & Precedent Analysis",
      features: [
        "Automated Case Search",
        "Precedent Identification",
        "Legal Citation Management",
        "Jurisprudence Analysis",
        "Research Reports"
      ]
    },
    {
      icon: "ri-brain-line",
      title: "AI-Driven Predictive Case Outcome Analysis",
      description: "Litigation Risk Assessment",
      features: [
        "Success Probability Estimation",
        "Risk Factor Identification",
        "Strategy Recommendations",
        "Historical Data Analysis",
        "Decision Support"
      ]
    },
    {
      icon: "ri-mail-send-line",
      title: "Email Marketing & Legal Newsletters",
      description: "Engaging and Retaining Clients with Targeted Campaigns",
      features: [
        "Newsletter Design & Distribution",
        "Client Segmentation",
        "Content Strategy",
        "Performance Tracking",
        "Automated Campaigns"
      ]
    },
    {
      icon: "ri-presentation-line",
      title: "Event & Webinar Promotion",
      description: "Organizing Online and Offline Legal Workshops",
      features: [
        "Event Planning & Management",
        "Registration Systems",
        "Marketing Materials",
        "Live Streaming Setup",
        "Post-Event Analytics"
      ]
    },
    {
      icon: "ri-global-line",
      title: "Legal Website Design & Development",
      description: "Custom, SEO-Optimized, and Mobile-Friendly Websites",
      features: [
        "Responsive Design",
        "SEO Optimization",
        "Content Management",
        "Client Portal Integration",
        "Analytics & Reporting"
      ]
    },
    {
      icon: "ri-translate-2",
      title: "Multilingual Website Development",
      description: "Reaching a Broader Audience",
      features: [
        "Arabic & English Support",
        "Cultural Adaptation",
        "Localized Content",
        "Language Switching",
        "International SEO"
      ]
    },
    {
      icon: "ri-calendar-check-line",
      title: "Online Consultation Booking Systems",
      description: "Simplifying Appointment Scheduling",
      features: [
        "Automated Scheduling",
        "Calendar Integration",
        "Reminder Notifications",
        "Payment Processing",
        "Client Management"
      ]
    },
    {
      icon: "ri-focus-line",
      title: "Conversion Rate Optimization (CRO)",
      description: "Maximizing Lead-to-Client Conversions",
      features: [
        "Landing Page Optimization",
        "A/B Testing",
        "User Experience Analysis",
        "Call-to-Action Enhancement",
        "Conversion Tracking"
      ]
    },
    {
      icon: "ri-mic-line",
      title: "Voice Search Optimization",
      description: "Making Websites Compatible with Google Assistant and Siri",
      features: [
        "Voice Query Optimization",
        "Natural Language Processing",
        "Featured Snippets",
        "Local SEO Enhancement",
        "Mobile Optimization"
      ]
    },
    {
      icon: "ri-file-list-3-line",
      title: "Attorney Directories & Listings Optimization",
      description: "Ensuring Law Firms Rank Well in Online Legal Directories",
      features: [
        "Profile Optimization",
        "Review Management",
        "Citation Building",
        "Directory Submissions",
        "Reputation Monitoring"
      ]
    },
    {
      icon: "ri-hand-heart-line",
      title: "Pro Bono Project Coordination",
      description: "Enhancing Community Impact & Strengthening Your Firm's Reputation",
      features: [
        "Project Planning",
        "Volunteer Coordination",
        "Impact Measurement",
        "PR & Communications",
        "Partnership Development"
      ]
    },
    {
      icon: "ri-shield-check-line",
      title: "Privacy Policy & Compliance Solutions",
      description: "Privacy Policy & Terms of Service Creation",
      features: [
        "GDPR Compliance",
        "Data Protection Policies",
        "Terms & Conditions",
        "Cookie Policies",
        "Regular Updates"
      ]
    },
    {
      icon: "ri-file-shield-line",
      title: "Secure Digital Signature Validation",
      description: "Ensuring the Legality of Electronic Contracts",
      features: [
        "E-Signature Integration",
        "Authentication Systems",
        "Audit Trails",
        "Legal Compliance",
        "Document Security"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-[#E8E4DC] font-mono">
      {/* Background Effects */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none"></div>
      <div className="fixed inset-0 opacity-[0.08] pointer-events-none">
        <div className="absolute top-[-10%] left-[-5%] w-[600px] h-[600px] rounded-[40%_60%_70%_30%/60%_30%_70%_40%] bg-gradient-radial from-[#4A4A4A] via-[#6A6A6A] to-[#8A8A8A] blur-[100px] animate-pulse"></div>
        <div className="absolute bottom-[-15%] right-[20%] w-[650px] h-[650px] rounded-[30%_70%_70%_30%/30%_30%_70%_70%] bg-gradient-radial from-[#6A6A6A] via-[#4A4A4A] to-[#5A5A5A] blur-[100px] animate-pulse"></div>
      </div>

      <div className="relative">
        {/* Header */}
        <header className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-6">
          <div className="max-w-[1200px] mx-auto flex justify-between items-center">
            <a href="/" className="text-2xl font-black text-[#4A4A4A] hover:text-teal-600 transition-colors cursor-pointer">
              ← BACK TO HOME
            </a>
          </div>
        </header>

        {/* Hero Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-teal-50/40 to-stone-50/40">
          <div className="max-w-[1200px] mx-auto text-center">
            <h1 className="text-[56px] md:text-[80px] font-black leading-none tracking-tight text-[#4A4A4A] mb-6">
              LEGAL AARON AI
            </h1>
            <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
              <div className="h-[1px]"></div>
            </div>
            <p className="text-xl text-[#4A4A4A] max-w-[900px] mx-auto mb-8">
              Transforming legal marketing through innovative, AI-powered solutions. A specialized division of Aaron AI, empowering law firms with cutting-edge digital strategies and automated tools.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="#services" className="inline-block bg-teal-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                EXPLORE SERVICES
              </a>
              <a href="mailto:elhawarybrothersllc@gmail.com" className="inline-block bg-[#4A4A4A] text-white px-6 py-3 text-sm font-bold hover:opacity-80 transition-opacity whitespace-nowrap cursor-pointer">
                CONTACT US
              </a>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                OUR MISSION & VISION
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto">
                <div className="h-[1px]"></div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="bg-gradient-to-br from-teal-100/60 to-teal-50/40 border-4 border-dashed border-teal-600 p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-600 border-2 border-dashed border-[#4A4A4A] mb-6">
                  <i className="ri-target-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-black text-[#4A4A4A] mb-4">OUR MISSION</h3>
                <p className="text-base text-[#4A4A4A] leading-relaxed">
                  To revolutionize legal marketing by harnessing cutting-edge artificial intelligence and automation technologies. We empower law firms to achieve excellence in client acquisition, engagement, and operational efficiency through tailored, innovative digital solutions. 🌟
                </p>
              </div>

              <div className="bg-gradient-to-br from-amber-100/60 to-amber-50/40 border-4 border-dashed border-amber-600 p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-600 border-2 border-dashed border-[#4A4A4A] mb-6">
                  <i className="ri-eye-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-black text-[#4A4A4A] mb-4">OUR VISION</h3>
                <p className="text-base text-[#4A4A4A] leading-relaxed">
                  To be recognized as the global leader in legal marketing and AI-driven automation. We aspire to transform the delivery of legal services, making high-quality legal expertise accessible worldwide while setting new benchmarks for innovation and professionalism. 🌍✨
                </p>
              </div>
            </div>

            {/* Core Values */}
            <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-8">
              <h3 className="text-3xl font-black text-[#4A4A4A] mb-6 text-center">OUR VALUES</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-3">
                    <i className="ri-lightbulb-line text-2xl text-teal-700"></i>
                  </div>
                  <h4 className="font-bold text-[#4A4A4A] mb-2">Innovation</h4>
                  <p className="text-sm text-[#4A4A4A]">Continuously pushing boundaries to create advanced, effective digital solutions</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-3">
                    <i className="ri-shield-check-line text-2xl text-teal-700"></i>
                  </div>
                  <h4 className="font-bold text-[#4A4A4A] mb-2">Integrity</h4>
                  <p className="text-sm text-[#4A4A4A]">Upholding the highest ethical standards with transparency and trust</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-3">
                    <i className="ri-user-heart-line text-2xl text-teal-700"></i>
                  </div>
                  <h4 className="font-bold text-[#4A4A4A] mb-2">Client-Centricity</h4>
                  <p className="text-sm text-[#4A4A4A]">Delivering measurable success and fostering lasting partnerships</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-3">
                    <i className="ri-team-line text-2xl text-teal-700"></i>
                  </div>
                  <h4 className="font-bold text-[#4A4A4A] mb-2">Collaboration</h4>
                  <p className="text-sm text-[#4A4A4A]">Cultivating strong, supportive relationships within our firm and with clients</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-3">
                    <i className="ri-star-line text-2xl text-teal-700"></i>
                  </div>
                  <h4 className="font-bold text-[#4A4A4A] mb-2">Excellence</h4>
                  <p className="text-sm text-[#4A4A4A]">Delivering superior quality in every service we offer</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-3">
                    <i className="ri-user-smile-line text-2xl text-teal-700"></i>
                  </div>
                  <h4 className="font-bold text-[#4A4A4A] mb-2">Human-Centric Future</h4>
                  <p className="text-sm text-[#4A4A4A]">AI empowers human potential - expertise, creativity, and empathy drive success 💡👥</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section id="services" className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                OUR COMPREHENSIVE SERVICES
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">
                A complete suite of legal marketing solutions powered by AI and automation
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {services.map((service, index) => (
                <div key={index} className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:border-teal-600 hover:bg-white/80 transition-all">
                  <div className="w-14 h-14 flex items-center justify-center bg-teal-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                    <i className={`${service.icon} text-2xl text-teal-700`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#4A4A4A] mb-2">{service.title}</h3>
                  <p className="text-sm text-[#4A4A4A] mb-4 opacity-80">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-xs text-[#4A4A4A]">
                        <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5"></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-teal-600/90 to-teal-700/90">
          <div className="max-w-[900px] mx-auto text-center">
            <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-white mb-6">
              READY TO TRANSFORM YOUR LAW FIRM?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-[700px] mx-auto">
              Contact us today to discover how our AI-powered solutions can elevate your legal practice
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="mailto:elhawarybrothersllc@gmail.com" className="inline-block bg-amber-600 text-white px-8 py-4 text-lg font-bold border-2 border-dashed border-white hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer">
                GET STARTED TODAY
              </a>
              <a href="/" className="inline-block bg-transparent border-2 border-dashed border-white text-white px-8 py-4 text-lg font-bold hover:bg-white hover:text-[#4A4A4A] transition-colors whitespace-nowrap cursor-pointer">
                BACK TO HOME
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="px-6 py-12 bg-stone-800 text-stone-200">
          <div className="max-w-[1200px] mx-auto text-center">
            <p className="text-stone-400 text-sm">© 2025 Legal Aaron AI - A Division of Aaron AI LLC. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </div>
  );
}
